<div class="content-wrapper">
    <div ng-class="item.indicatorColor" style="width: 3px;"></div>
    <div ng-show="showCheckboxes" style="padding: 16px 0 0 5px; font-size: 0.65em;">
        <span class="fa-stack"><i class="fa fa-square-o fa-stack-2x"></i><i ng-show="checked()" class="fa fa-check fa-stack-1x"></i></span>
    </div>
    <div style="flex: auto; padding: 5px;">
        <h3>
            <a ng-click="viewDetails(item.id)">{{ item.displayName }}</a>
        </h3>
        <div style="padding: 5px 0 0 0">
            <span>{{ item.userType }}</span> <span style="color: #d0d0d0;">&ndash;</span> <span>{{ item.userName }}</span> <span style="color: #d0d0d0;">&ndash;</span> <span>{{ item.email }}</span>
        </div>
    </div>
</div>